export const OPEN_REQUEST_CALLBACK_MODAL_HASH = 'openModalRequestCallbackMotorwayMove';

export const MOTORWAY_MOVE_UNAUTHORISED_PARAM = 'motorwaymove';

// Set to null to hide the video
export const MOTORWAY_MOVE_VIDEO_ID: string | null = 'cZ5E59584vk';
